var map = {
	"./docx.svg": [
		46085,
		85
	],
	"./jpg.svg": [
		65600,
		600
	],
	"./md.svg": [
		31249,
		249
	],
	"./pdf.svg": [
		59240,
		240
	],
	"./png.svg": [
		23587,
		587
	],
	"./pptx.svg": [
		54465,
		465
	],
	"./txt.svg": [
		56001,
		1
	],
	"./xlsx.svg": [
		56876,
		876
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 42441;
module.exports = webpackAsyncContext;